import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Products from './components/Products'; // Ensure this file exists
import About from './components/About'; // Ensure this file exists
import Contact from './components/Contact'; // Ensure this file exists
import TenderForm from './components/TenderForm'; // Ensure this file exists
import AuctionForm from './components/AuctionForm'; // Ensure this file exists
import CakeApp from './components/CakeApp'; // Ensure this file exists
import CookieConsentBanner from './components/CookieConsentBanner';
import Maincomponent from './components/Maincomponent'; // Ensure this file exists

function App() {
  return (
    <Router>
      <div>
        <CookieConsentBanner />
        <Maincomponent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tenderform" element={<TenderForm />} />
          <Route path="/auctionform" element={<AuctionForm />} />
          <Route path="/cakeapp" element={<CakeApp />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;